import React, {Component} from 'react';

export default class CustomerBar extends Component {
    render(){
        const usLimited = localStorage.getItem('us_limited');
       
        // If us_limited, only show Products and Orders for this customer bar
        if (usLimited === '1') {
          return (
            <div className="left-sidebar">
              <div className="scroll-sidebar">
                <br/>
                <nav className="sidebar-nav">
                  <ul id="sidebarnav">
                    <li className="nav-divider"></li>
                    <li> <a href="/customer-products" aria-expanded="false">&nbsp;Products</a> </li>
                    <li> <a href="/customer-orderentry" aria-expanded="false">&nbsp;Order Entry</a> </li>
                  </ul>
                </nav>
              </div>
            </div>
          );
        }

        return (
        
        <div className="left-sidebar" >
           
            <div className="scroll-sidebar">
                   <br/>
                <nav className="sidebar-nav">
                     
                     <ul id="sidebarnav">                        
                         <li className="nav-divider"></li>
                         <li> <a href="/customer-products" aria-expanded="false">&nbsp;Products</a> </li>
                         <li> <a href="/customer" aria-expanded="false">&nbsp;Orders</a> </li>
                         <li> <a href="/customer-pickups" aria-expanded="false">&nbsp;Pickups</a> </li>
                         <li> <a href="/customer-receivers" aria-expanded="false">&nbsp;Receivers</a> </li>     
                         <li> <a href="/customer-returns" aria-expanded="false">&nbsp;Returns</a> </li>                    
                         <li> <a href="/customer-requests" target="_new" aria-expanded="false">&nbsp;Requests</a> </li>
                     </ul>

                <div className="panel-heading">
                    <h4 className="panel-title">
                    <a data-toggle="collapse" href="#collapse5">Reports</a>
                    </h4>
                </div>
                <div id="collapse5" className="panel-collapse collapse">
                    <ul className="list-group">        
                        <li> <a href="/customer-report-billing" aria-expanded="false">&nbsp;Billing</a> </li> 
                        <li> <a href="/customer-report-item-billing" aria-expanded="false">&nbsp;Item Billing</a> </li>                         
                    </ul>                   
                </div>

                </nav>
               
            </div>
            
        </div>
       
                )
    }
}